import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const OtherAmount = ({ handleDonateClick }) => {
    const [amount, setAmount] = useState('');
    const [isFocused, setIsFocused] = useState(false);

    const getEmoji = (value) => {
        const num = parseInt(value) || 0;
        if (num >= 10000) return '💎';
        if (num >= 5000) return '💅';
        if (num >= 2000) return '🥵';
        if (num >= 1000) return '🥳';
        if (num >= 500) return '🥰';
        if (num >= 100) return '😀';
        return '🙂';
    };

    const emoji = getEmoji(amount);

    return (
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3 }}
            className="lg:my-32 my-1 p-6 bg-white rounded-xl shadow-md"
        >
            <div className="mb-4">
                <label className="block text-gray-700 mb-2 font-medium">Ingresa tu monto (MXN)</label>
                <motion.div
                    animate={{
                        borderColor: (parseInt(amount) || 0) >= 5000 ? '#D4AF37' : isFocused ? '#3B82F6' : '#E5E7EB',
                        boxShadow: isFocused ? '0 0 0 3px rgba(59, 130, 246, 0.2)' : 'none'
                    }}
                    className={`border-2 rounded-lg p-1 transition-all ${(parseInt(amount) || 0) >= 5000 ? 'border-gold-500' : ''}`}
                >
                    <input
                        type="number"
                        value={amount}
                        onChange={(e) => setAmount(e.target.value)}
                        onFocus={() => setIsFocused(true)}
                        onBlur={() => setIsFocused(false)}
                        className="w-full p-3 text-lg outline-none"
                        placeholder="Ej: 750"
                        min="1"
                    />
                </motion.div>
                {amount && (parseInt(amount) < 50 || parseInt(amount) > 1800) && (
                    <motion.p className='text-red-500 mt-2 text-sm'>El monto debe ser entre $50 MXN y $18,000 MXN</motion.p>
                )}

                <AnimatePresence mode="wait">
                    <motion.div
                        key={emoji}
                        initial={{ opacity: 0, y: -10 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: 10 }}
                        transition={{ duration: 0.2 }}
                        className="text-center text-4xl my-4 h-12"
                    >
                        {emoji}
                    </motion.div>
                </AnimatePresence>
            </div>

            <motion.button
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                onClick={() => handleDonateClick(amount)}
                disabled={!(parseInt(amount) >= 50 && parseInt(amount) <= 18000)}
                className={`font-lato uppercase w-full py-3 px-6 rounded-lg font-bold text-white ${(parseInt(amount) || 0) >= 5000 ? 'bg-gradient-to-r from-yellow-500 to-yellow-600' : 'bg-idarkblue'
                    } transition-all`}
            >
                Continuar
            </motion.button>
        </motion.div>
    );
};

export default OtherAmount;